module.exports = __webpack_public_path__ + "assets/img/00130.0a7a6b90.png";